// extracted by mini-css-extract-plugin
export default {"truncated":"TruncatedText_truncated__ydGvC","truncated__text":"TruncatedText_truncated__text__4bt6s","truncated__more":"TruncatedText_truncated__more__eLEbF"};